import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAssetsTypes } from "services/assets-types.service";
import { AssetsTypesEntity } from "types/Asset";

// Define the types for your initial state
interface assetsTypesContainerState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  collection: AssetsTypesEntity[];
}

const initialState: assetsTypesContainerState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  collection: [],
};

const assetsTypesContainerSlice = createSlice({
  name: "assets-types",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(
      state: assetsTypesContainerState,
      action: PayloadAction<boolean>
    ) {
      state.isLoading = action.payload;
    },
    setError(
      state: assetsTypesContainerState,
      action: PayloadAction<{ error: string }>
    ) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state: assetsTypesContainerState, action: PayloadAction<any>) {
      state.collection = action.payload;
      state.isLoading = false;
      state.isError = false;
    },
  },
});

const { actions, reducer } = assetsTypesContainerSlice;

export const { setDestroy, setLoading, setError, setData } = actions;
export default reducer;

// Only the newest request may change the state: after a company switch or a reload,
// an older answer would show the wrong list or an error that no longer applies.
let latestRequest = 0;

export const fetchAssetsTypesList =
  (companyId: string) => async (dispatch: any) => {
    latestRequest += 1;
    const request = latestRequest;
    dispatch(setLoading(true));
    try {
      const data = await fetchAssetsTypes(companyId);
      if (request === latestRequest) dispatch(setData(data));
    } catch (e) {
      const error = "not_fetch";
      if (request === latestRequest) dispatch(setError({ error }));
    }
  };
